function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconShareLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.675 3.56v3.66h5.462c.744 0 1.348.604 1.348 1.347v8.835c0 .745-.604 1.348-1.349 1.348H3.863a1.349 1.349 0 01-1.348-1.348V8.567c0-.744.603-1.348 1.348-1.348h5.461V3.56l-1.64 1.639a.676.676 0 01-.956-.956l2.797-2.796c.13-.13.3-.196.471-.196l.006.002c.171 0 .342.065.47.194l.96.96 1.837 1.836a.676.676 0 01-.956.956L10.676 3.56zM9.325 8.57H3.867v8.828h12.266V8.571h-5.458v2.817a.675.675 0 01-1.352 0V8.571zm-3.43-1.35v1.35h8.211V7.22H5.894zm3.43 0h1.351v1.35H9.324V7.22z",
    fill: props.color
  }));
}

export default SvgIconShareLarge;